export const cancelBookingCode = {
  body: {
    bookingId: "D0624-2192",
  },

  response: {
    bookingId: "D0624-2192",
    bookingStatus: "CANCELLED",
    cancellationFee: "0 USD",
    cancellationPolicy:
      "Any cancellation on or after Wednesday, 14th August 2024 at 10:00 is non-refundable",
  },
};



export const cancelBookingCodeImplementation = {
    nodejs_Axios: `
  const axios = require('axios');
  let data = JSON.stringify({
    "bookingId": "D0824-2265"
  });
  
  let config = {
    method: 'patch',
    maxBodyLength: Infinity,
    url: 'https://testapi.drivado.com/api/v1/api/apicancelBooking?email=W1user1@email.com',
    headers: { 
      'apikey': 'iL9e30CjZfRok2FuH6KC1xuqCa7C3K', 
      'Content-Type': 'application/json'
    },
    data : data
  };
  
  axios.request(config)
  .then((response) => {
    console.log(JSON.stringify(response.data));
  })
  .catch((error) => {
    console.log(error);
  });
  `,
    python: `
  import requests
  import json
  
  url = "https://testapi.drivado.com/api/v1/api/apicancelBooking?email=W1user1@email.com"
  
  payload = json.dumps({
    "bookingId": "D0824-2265"
  })
  headers = {
    'apikey': 'iL9e30CjZfRok2FuH6KC1xuqCa7C3K',
    'Content-Type': 'application/json'
  }
  
  response = requests.request("PATCH", url, headers=headers, data=payload)
  
  print(response.text)
  `,
    go: `
  package main
  
  import (
    "bytes"
    "encoding/json"
    "fmt"
    "net/http"
  )
  
  func main() {
    url := "https://testapi.drivado.com/api/v1/api/apicancelBooking?email=W1user1@email.com"
  
    payload := map[string]string{"bookingId": "D0824-2265"}
    jsonData, _ := json.Marshal(payload)
  
    req, _ := http.NewRequest("PATCH", url, bytes.NewBuffer(jsonData))
    req.Header.Set("apikey", "iL9e30CjZfRok2FuH6KC1xuqCa7C3K")
    req.Header.Set("Content-Type", "application/json")
  
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
  
    var result map[string]interface{}
    json.NewDecoder(resp.Body).Decode(&result)
  
    fmt.Println(result)
  }
  `,
    curl: `
  curl --location --request PATCH 'https://testapi.drivado.com/api/v1/api/apicancelBooking?email=W1user1@email.com' \\
  --header 'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K' \\
  --header 'Content-Type: application/json' \\
  --data-raw '{
    "bookingId": "D0824-2265"
  }'
  `,
    php: `
  <?php
  
  $curl = curl_init();
  
  $data = json_encode(array("bookingId" => "D0824-2265"));
  
  curl_setopt_array($curl, array(
    CURLOPT_URL => 'https://testapi.drivado.com/api/v1/api/apicancelBooking?email=W1user1@email.com',
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_ENCODING => '',
    CURLOPT_MAXREDIRS => 10,
    CURLOPT_TIMEOUT => 0,
    CURLOPT_FOLLOWLOCATION => true,
    CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
    CURLOPT_CUSTOMREQUEST => 'PATCH',
    CURLOPT_POSTFIELDS => $data,
    CURLOPT_HTTPHEADER => array(
      'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K',
      'Content-Type: 'application/json'
    ),
  ));
  
  $response = curl_exec($curl);
  
  curl_close($curl);
  echo $response;
  ?>
  `
  }